import seoReducer from 'src/redux/reducers/seo';
import { combineReducers } from 'redux';


export default combineReducers({ seoReducer });
